var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { LitElement } from 'lit';
import { DateHelper } from '../../helpers/index';
/**
 * Base class for DinapsisDateRange component.
 */
export class DinapsisDateRangeBase extends LitElement {
    constructor() {
        super();
        const now = DateHelper.getYearMonthDayString(new Date());
        this.startDate = now;
        this.endDate = now;
    }
}
__decorate([
    property({ type: String })
], DinapsisDateRangeBase.prototype, "startDate", void 0);
__decorate([
    property({ type: String })
], DinapsisDateRangeBase.prototype, "endDate", void 0);
//# sourceMappingURL=dinapsis-date-range-base.js.map